/**
 * Frame hook using node-localstorage instead of FrameContext
 */
import { Frame } from '..';
import { NodeStorageKey, SafeNodeStorage } from '~/services/storage';
import { useRef } from 'react';
import { normalizeCulture } from '../utils/normalizeCulture';

// Initialize storage (Node only)
let storage: SafeNodeStorage | null = null;

if (typeof window === 'undefined') {
    const { LocalStorage } = require('node-localstorage');
    storage = new SafeNodeStorage(new LocalStorage('./scratch'));
}

export const useFrame = () => {
    // Server-side storage
    const storedFrameData: Frame | null = storage ? storage.get(NodeStorageKey.FRAME) : null;

    // Client-side fallback
    const windowFrameData: Frame | null = typeof window !== 'undefined' ? window.__frame : null;

    const source = windowFrameData ?? storedFrameData ?? ({} as Frame);

    const data = useRef<Frame>({
        ...source,
        culture: normalizeCulture(source.culture),
        market: {
            ...source?.market,
        },
    });

    return { data: data.current };
};
